// API Configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_ENGEN_API_HOST || 'http://localhost:8000',
} as const

export const getApiUrl = (path: string): string => {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${API_CONFIG.BASE_URL}${normalizedPath}`
}
